import Regex from '../Regex'

export default class Numeric extends Regex {
  get ruleName () {
    return 'numeric'
  }

  passes () {
    return super.passes(/^\d+$/)
  }
}
